export const sortDates = (prop: string, direction: string) => {
  const sorted = (a: any, b: any) => {
    return direction === 'asc'
      ? new Date(b[prop]).valueOf() - new Date(a[prop]).valueOf()
      : new Date(a[prop]).valueOf() - new Date(b[prop]).valueOf()
  }
  return sorted
}

export const sortStrings = (prop: string, direction: string) => {
  const sorted = (a: any, b: any) => {
    if (a[prop] > b[prop]) {
      return direction === 'asc' || prop === 'none' ? 1 : -1
    } else if (a[prop] < b[prop]) {
      return direction === 'asc' || prop === 'none' ? -1 : 1
    }
    return 0
  }
  return sorted
}

export const sortNumbers = (prop: string, direction: string) => {
  const sorted = (a: any, b: any) => {
    return direction === 'asc'
      ? Number(b[prop]) - Number(a[prop])
      : Number(a[prop]) - Number(b[prop])
  }
  return sorted
}
